import Raven from "raven-js";
import React from "react";
import ReactDOM from "react-dom";
import "typeface-montserrat";
import "typeface-lato";
import "@ep/react-components/umd/ReactComponents.css";
import "./styles/index.scss";
import reducer from "./reducers/appReducer";
import thunkMiddleware from "redux-thunk";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import App from "./App";
import { isDevEnv } from "./lib/utils";

let middleware = [thunkMiddleware];

if (process.env.NODE_ENV !== "production") {
  const { logger } = require("./lib/utils");
  middleware = [...middleware, logger];
}
if (!isDevEnv()) {
  const sentryURL =
    "https://5840219223b44e0dac76bedd2fa5e3d7@o1423188.ingest.sentry.io/4504514427748352";
  Raven.config(sentryURL, {
    environment: process.env.NODE_ENV,
    dataCallback(data) {
      Object.assign(data.extra != null ? data.extra : (data.extra = {}), {
        location_hash: window.location.hash
      });
      return data;
    }
  }).install();
}

const store = createStore(reducer, applyMiddleware(...middleware));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
